<template>
  <div>
    <div v-if="rates !== null" class="profile__dropdown-title">
      {{ $tr('profile.group.rates') }}
      <span>{{ getTariffById(rates.tariff_id) !== null ? getTariffById(rates.tariff_id).name : '' }}</span>
    </div>

    <ul class="profile__dropdown-list">
      <li class="profile__dropdown-item">
        <div v-if="!isRatesExpired" class="rates-info-row">
          {{ $tr('rates.paidTo') }}:
          <span
            class="info"
            :class="{
              'is-warning': ratesLeftDays && ratesLeftDays <= 30 && ratesLeftDays > 10,
              'is-error': ratesLeftDays && ratesLeftDays <= 10
            }"
          >
            {{ paid_to }}
          </span>
        </div>
        <div v-else class="rates-info-row">
          {{ !isRatesStarted ? $tr('rates.notStart') : $tr('rates.expiredProfile') }}
        </div>
      </li>

      <li class="profile__dropdown-item">
        <div class="rates-info-row">
          {{ $tr('rates.responses.left') }}:
          <span
            class="info"
            :class="{
              'is-warning': response_balance !== null && response_balance <= 30 && response_balance > 10,
              'is-error': response_balance !== null && response_balance <= 10
            }"
          >
            {{ response_balance !== null ? response_balance : $tr('rates.noLimit') }}
          </span>
        </div>
      </li>

      <li class="profile__dropdown-item">
        <div class="rates-info-row">
          {{ $tr('rates.vacancies.left') }}:
          <span
            class="info"
            :class="{
              'is-warning':
                vacancies_balance_percent !== null && vacancies_balance_percent <= 30 && vacancies_balance_percent > 10,
              'is-error': vacancies_balance_percent !== null && vacancies_balance_percent <= 10
            }"
          >
            {{
              vacancy_balance !== null
                ? vacancy_balance + ' ' + $tr('rates.from') + ' ' + vacancy_limit
                : $tr('rates.noLimit')
            }}
          </span>
        </div>
      </li>

      <li class="profile__dropdown-item">
        <div v-if="is_sms_enabled" class="rates-info-row">
          {{ $tr('rates.responses.smsLeft') }}:
          <span
            class="info"
            :class="{
              'is-warning': !is_sms_unlimited && sms_balance <= 50 && sms_balance > 10,
              'is-error': !is_sms_unlimited && sms_balance <= 10
            }"
          >
            {{ !is_sms_unlimited ? sms_balance : $tr('rates.noLimit') }}
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'RatesInfo',

  computed: {
    ...mapState('company_new', ['rates']),

    ...mapGetters('company_new', [
      'isRatesExpired',
      'isRatesStarted',
      'ratesLeftDays',
      'response_balance',
      'getTariffById'
    ]),

    ...mapGetters('locale', ['is_japan_locale']),

    paid_to() {
      if (!this.rates || (!this.rates.paid_to && this.rates.paid_to !== null)) {
        return '';
      }

      if (this.rates.paid_to === null) {
        return this.$tr('rates.noLimit');
      }

      const dateFormat = this.is_japan_locale ? 'YYYY.MM.DD' : 'DD MMMM YYYY';

      return this.$moment(this.rates.paid_to).format(dateFormat);
    },

    is_sms_enabled() {
      if (!this.rates) {
        return false;
      }

      return this.rates ? this.rates.is_sms_enabled : false;
    },

    is_sms_unlimited() {
      if (!this.rates) {
        return false;
      }

      return this.rates ? this.rates.is_sms_unlimited : false;
    },

    vacancy_balance() {
      if (!this.rates) {
        return null;
      }

      return this.rates.vacancy_balance;
    },

    vacancy_limit() {
      if (!this.rates) {
        return null;
      }

      return this.rates.vacancy_limit;
    },

    vacancies_balance_percent() {
      if (!this.rates || this.rates.vacancy_balance === null || this.rates.vacancy_limit === null) {
        return null;
      }

      const percent = (this.rates.vacancy_balance / this.rates.vacancy_limit) * 100;

      return percent;
    },

    sms_balance() {
      if (!this.rates) {
        return null;
      }

      return this.rates.sms_balance;
    }
  }
};
</script>

<style lang="scss" scoped>
li.rates-info {
  margin: 0;
}

.info {
  color: $green;
}

.is-warning {
  color: $orange;
}

.is-error {
  color: $red;
}

.profile {
  &__dropdown-title {
    text-transform: capitalize;

    @media screen and (max-width: 992px) {
      text-align: center;
    }
  }

  @media screen and (max-width: 992px) {
    &__dropdown-item {
      justify-content: center;
    }
  }
}
</style>
